import { SPECIALIST } from "../constants";

const initialState = {
  limit: 50,
  offset: 0,
  total: 0,
  query: "",
  specialists: [],
  specialist: null,
  isLoadingGetSpecialist: false,
  isLoadingGetSpecialists: false,
  isLoadingCreateSpecialist: false,
  isLoadingUpdateSpecialist: false,
  isLoadingDeleteSpecialist: false,
  isLoadingAvailability: false,
  error: null,
};

const specialistReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SPECIALIST.GET_SPECIALISTS:
      return { ...state, isLoadingGetSpecialists: true };
    case SPECIALIST.GET_SPECIALISTS_FAILURE:
      return { ...state, isLoadingGetSpecialists: false, error: action.payload };
    case SPECIALIST.GET_SPECIALISTS_SUCCESS:
      return {
        ...state,
        isLoadingGetSpecialists: false,
        specialists: action.payload.data,
        total: action.payload.total,
        error: null,
      };
    case SPECIALIST.GET_SPECIALIST:
      return { ...state, isLoadingGetSpecialist: true };
    case SPECIALIST.GET_SPECIALIST_FAILURE:
      return { ...state, isLoadingGetSpecialist: false, error: action.payload };
    case SPECIALIST.GET_SPECIALIST_SUCCESS:
      return {
        ...state,
        isLoadingGetSpecialist: false,
        specialist: action.payload,
        error: null,
      };
    case SPECIALIST.CREATE_SPECIALIST:
      return { ...state, isLoadingCreateSpecialist: true };
    case SPECIALIST.CREATE_SPECIALIST_FAILURE:
      return { ...state, isLoadingCreateSpecialist: false, error: action.payload };
    case SPECIALIST.CREATE_SPECIALIST_SUCCESS:
      return {
        ...state,
        isLoadingCreateSpecialist: false,
        specialist: action.payload,
        error: null,
      };
    case SPECIALIST.UPDATE_SPECIALIST:
      return { ...state, isLoadingUpdateSpecialist: true };
    case SPECIALIST.UPDATE_SPECIALIST_FAILURE:
      return { ...state, isLoadingUpdateSpecialist: false, error: action.payload };
    case SPECIALIST.UPDATE_SPECIALIST_SUCCESS:
      return {
        ...state,
        isLoadingUpdateSpecialist: false,
        specialist: action.payload,
        error: null,
      };
    case SPECIALIST.DELETE_SPECIALIST:
      return { ...state, isLoadingDeleteSpecialist: true };
    case SPECIALIST.DELETE_SPECIALIST_FAILURE:
      return { ...state, isLoadingDeleteSpecialist: false, error: action.payload };
    case SPECIALIST.DELETE_SPECIALIST_SUCCESS:
      return { ...state, isLoadingDeleteSpecialist: false, error: null };
    case SPECIALIST.ADD_AVAILABILITY:
    case SPECIALIST.DELETE_AVAILABILITY:
      return { ...state, isLoadingAvailability: true };
    case SPECIALIST.ADD_AVAILABILITY_FAILURE:
    case SPECIALIST.DELETE_AVAILABILITY_FAILURE:
      return { ...state, isLoadingAvailability: false, error: action.payload };
    case SPECIALIST.ADD_AVAILABILITY_SUCCESS:
    case SPECIALIST.DELETE_AVAILABILITY_SUCCESS:
      return {
        ...state,
        isLoadingAvailability: false,
        specialist: action.payload,
        error: null,
      };
    case SPECIALIST.SET_OFFSET:
      return { ...state, offset: action.payload };
    case SPECIALIST.SET_QUERY:
      return { ...state, query: action.payload, offset: 0 };
    case SPECIALIST.CLEAN_ERROR:
      return { ...state, error: null };
    case SPECIALIST.CLEAN_SPECIALIST:
      return { ...initialState };
    default:
      return state;
  }
};

export default specialistReducer;
